import React from 'react';

import ItemLabel from './ItemLabel';

const Result = ({ label, variant, result = {} }) => (
  <div className="row">
    <div className="col col-5 text-right">{label}</div>
    <div className="col">
      <div className="list-group list-group-accent mb-2">
        <div
          className={`list-group-item list-group-item-accent-${variant} bg-dark text-left py-1`}
        >
          {Object.entries(result)
            .filter(([id, count]) => count !== 0)
            .map(([id, count]) => (
              <div key={id}>
                <ItemLabel id={id} />{' '}
                <label className={`badge badge-${variant} text-dark`}>
                  {count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </label>
              </div>
            ))}
        </div>
      </div>
    </div>
  </div>
);

export default Result;
